'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _chunk2 = require('lodash/chunk');

var _chunk3 = _interopRequireDefault(_chunk2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _AppConstants = require('../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _utils = require('../../utils');

var _util = require('../../utils/util');

var _common = require('../common');

var _mightyFields = require('../../lib/mighty-fields');

var _DocumentTemplatesTable = require('./main-documents/DocumentTemplates/DocumentTemplatesTable');

var _DocumentTemplatesTable2 = _interopRequireDefault(_DocumentTemplatesTable);

var _DeleteLienButton = require('./DeleteLienButton');

var _DeleteLienButton2 = _interopRequireDefault(_DeleteLienButton);

var _LienDocuments = require('./main-fundings/LienDocuments');

var _LienDocuments2 = _interopRequireDefault(_LienDocuments);

var _MedicalCodesFormGroup = require('./MedicalCodesFormGroup');

var _MedicalCodesFormGroup2 = _interopRequireDefault(_MedicalCodesFormGroup);

var _MedicalCodesTable = require('./MedicalCodesTable');

var _MedicalCodesTable2 = _interopRequireDefault(_MedicalCodesTable);

var _medicalDetailsConfig = require('./medicalDetailsConfig');

var _medicalDetailsConfig2 = _interopRequireDefault(_medicalDetailsConfig);

var _ReturnDetailsWell = require('./ReturnDetailsWell');

var _ReturnDetailsWell2 = _interopRequireDefault(_ReturnDetailsWell);

var _CapitalFundingsList = require('./main-details/capital-fundings/CapitalFundingsList');

var _FieldSets = require('./main-applications/FieldSets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APPLICATION_MODELS = _AppConstants2.default.APPLICATION_MODELS,
    PERMISSIONS = _AppConstants2.default.PERMISSIONS;
var applicationConfig = _medicalDetailsConfig2.default.applicationConfig,
    medicalFacilityConfig = _medicalDetailsConfig2.default.medicalFacilityConfig,
    medicalFacilityContactConfig = _medicalDetailsConfig2.default.medicalFacilityContactConfig,
    medicalProviderConfig = _medicalDetailsConfig2.default.medicalProviderConfig;
var formatDate = _utils.FormattingUtils.formatDate;
var MedicalDetailsModal = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'CaseStore', 'FunderStore', 'LienStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(MedicalDetailsModal, _Component);

  function MedicalDetailsModal(props) {
    _classCallCheck(this, MedicalDetailsModal);

    var _this = _possibleConstructorReturn(this, (MedicalDetailsModal.__proto__ || Object.getPrototypeOf(MedicalDetailsModal)).call(this, props));

    _initDefineProp(_this, 'lien', _descriptor, _this);

    _initDefineProp(_this, 'application', _descriptor2, _this);

    _initDefineProp(_this, 'medicalFacility', _descriptor3, _this);

    _initDefineProp(_this, 'showDeleteLienConfirmation', _descriptor4, _this);

    _initDefineProp(_this, 'editMedicalCodes', _descriptor5, _this);

    _initDefineProp(_this, 'loading', _descriptor6, _this);

    _this.fetchLien();
    return _this;
  }

  _createClass(MedicalDetailsModal, [{
    key: 'fetchLien',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, LienStore, lienId, ApplicationStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, LienStore = _props.LienStore, lienId = _props.lienId, ApplicationStore = _props.ApplicationStore;
                _context.next = 3;
                return LienStore.retrieve(lienId, 'medical', { includeDocuments: true });

              case 3:
                this.lien = _context.sent;

                if (!this.lien.application) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return ApplicationStore.retrieve(this.lien.application, APPLICATION_MODELS.MEDICAL.model);

              case 7:
                this.application = _context.sent;

              case 8:

                this.medicalFacility = this.lien.medical_facility;
                this.loading = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchLien() {
        return _ref.apply(this, arguments);
      }

      return fetchLien;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var _props2, CaseStore, LienStore;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, CaseStore = _props2.CaseStore, LienStore = _props2.LienStore;
                _context2.next = 3;
                return LienStore.update(this.lien, data);

              case 3:
                this.lien = _context2.sent;


                if (this.application) {
                  this.application = _extends({}, this.application, { lien: this.lien });
                }
                _context2.next = 7;
                return CaseStore.refresh(this.lien.case);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function update(_x) {
        return _ref2.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'deleteMedicalCode',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(code) {
        var LienStore;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                LienStore = this.props.LienStore;

                this.lien.codes = this.lien.codes.filter(function (medicalCode) {
                  return !(0, _isEqual3.default)((0, _mobx.toJS)(code), medicalCode);
                });
                _context3.next = 4;
                return LienStore.update(this.lien, { codes: (0, _mobx.toJS)(this.lien.codes) });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteMedicalCode(_x2) {
        return _ref3.apply(this, arguments);
      }

      return deleteMedicalCode;
    }()
  }, {
    key: 'renderApplicationInformation',
    value: function renderApplicationInformation() {
      if (!this.application) {
        return null;
      }

      var titleNode = _react2.default.createElement(
        _Row2.default,
        null,
        _react2.default.createElement(
          _common.InfoWell.Label,
          null,
          'Application'
        ),
        _react2.default.createElement(
          _common.InfoWell.Value,
          { className: 'secondary' },
          'Created At: ',
          formatDate(this.application.created_at)
        )
      );

      return _react2.default.createElement(_mightyFields.Card, {
        fieldSets: applicationConfig,
        model: this.application,
        title: titleNode
      });
    }
  }, {
    key: 'renderMedicalFundingInfo',
    value: function renderMedicalFundingInfo() {
      var _props3 = this.props,
          _props3$FunderStore = _props3.FunderStore,
          isMedicalProvider = _props3$FunderStore.isMedicalProvider,
          isFinanceCustomer = _props3$FunderStore.isFinanceCustomer,
          SessionStore = _props3.SessionStore,
          funded = (0, _get3.default)(this.lien, 'is_confirmed'),
          canCloseLiens = !!SessionStore.userHasPermission(PERMISSIONS.CLOSE_LIEN);


      return _react2.default.createElement(_mightyFields.EditableCard, {
        fieldSets: (0, _FieldSets.fieldSetsMedicalApplication)({
          canCloseLiens: canCloseLiens,
          finalize: funded,
          hasCoopInvestment: this.lien.hasCoopInvestment,
          isFinanceCustomer: isFinanceCustomer,
          isMedicalProvider: isMedicalProvider,
          showIsOpen: true
        }),
        model: this.lien,
        onSave: this.update,
        title: 'Medical Lien Info'
      });
    }
  }, {
    key: 'renderReturnDetails',
    value: function renderReturnDetails() {
      var _this2 = this;

      return (0, _get3.default)(this.lien, 'lien_returns', []).map(function (lien_return) {
        return _react2.default.createElement(_ReturnDetailsWell2.default, { key: lien_return.id, lien: _this2.lien, lien_return: lien_return });
      });
    }
  }, {
    key: 'renderMedicalFacilityInfo',
    value: function renderMedicalFacilityInfo() {
      var readFields = medicalFacilityConfig.readFields,
          writeFields = medicalFacilityConfig.writeFields;


      return _react2.default.createElement(_mightyFields.CRUDCard, {
        fieldSets: readFields,
        model: (0, _get3.default)(this.lien, 'medical_facility') || {},
        onSave: this.update,
        title: 'Medical Facility',
        wrapperName: 'medical_facility',
        writeFields: writeFields
      });
    }
  }, {
    key: 'renderCapitalProviders',
    value: function renderCapitalProviders() {
      var FunderStore = this.props.FunderStore,
          _lien = this.lien,
          capital_fundings = _lien.capital_fundings,
          id = _lien.id;


      if (!FunderStore.canSeeCapitalProviders || !id) {
        return;
      }

      return _react2.default.createElement(_CapitalFundingsList.GuardedCapitalFundingsList, {
        lienId: id,
        capitalFundings: (0, _mobx.toJS)(capital_fundings)
      });
    }
  }, {
    key: 'renderMedicalProviderInfo',
    value: function renderMedicalProviderInfo() {
      var lien = this.lien,
          data = _extends({}, (0, _get3.default)(lien, 'medical_provider'), (0, _get3.default)(lien, 'medical_provider.additional_contact_info')),
          readFields = medicalProviderConfig.readFields,
          writeFields = medicalProviderConfig.writeFields;


      return _react2.default.createElement(_mightyFields.CRUDCard, {
        fieldSets: readFields,
        model: data || {},
        onSave: this.update,
        title: 'Medical Provider',
        wrapperName: 'medical_provider',
        writeFields: writeFields
      });
    }
  }, {
    key: 'renderMedicalFacilityContactInfo',
    value: function renderMedicalFacilityContactInfo() {
      var lien = this.lien,
          data = _extends({}, (0, _get3.default)(lien, 'medical_facility_contact'), (0, _get3.default)(lien, 'medical_facility_contact.additional_contact_info')),
          readFields = medicalFacilityContactConfig.readFields,
          writeFields = medicalFacilityContactConfig.writeFields;


      return _react2.default.createElement(_mightyFields.CRUDCard, {
        fieldSets: readFields,
        model: data || {},
        onSave: this.update,
        title: 'Medical Facility Contact',
        wrapperName: 'medical_facility_contact',
        writeFields: writeFields
      });
    }
  }, {
    key: 'renderDocumentTemplates',
    value: function renderDocumentTemplates() {
      var _props4 = this.props,
          caseId = _props4.caseId,
          FunderStore = _props4.FunderStore;


      if (!this.lien || !FunderStore.medicalLienTemplates.length) {
        return null;
      }

      return _react2.default.createElement(_DocumentTemplatesTable2.default, {
        caseId: caseId,
        isFaxEnabled: false,
        lienId: this.lien.id,
        documentTemplates: (0, _mobx.toJS)(FunderStore.medicalLienTemplates),
        onDownloadClick: FunderStore.downloadFunderTemplate
      });
    }
  }, {
    key: 'renderMedicalLienDocuments',
    value: function renderMedicalLienDocuments() {
      if (!this.lien || !this.lien.documents) {
        return null;
      }

      return _react2.default.createElement(_LienDocuments2.default, {
        documents: (0, _mobx.toJS)((0, _get3.default)(this.lien, 'documents')),
        lien: this.lien
      });
    }
  }, {
    key: 'updateCustomFields',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(custom_field_data) {
        var LienStore, customFieldData, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                LienStore = this.props.LienStore, customFieldData = (0, _get3.default)(this.lien, 'custom_field_data', {}), data = { custom_field_data: _extends({}, customFieldData, custom_field_data) };
                _context4.next = 3;
                return LienStore.update(this.lien, data);

              case 3:
                this.lien = _context4.sent;

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateCustomFields(_x3) {
        return _ref4.apply(this, arguments);
      }

      return updateCustomFields;
    }()
  }, {
    key: 'renderCustomLienFields',
    value: function renderCustomLienFields() {
      var _this3 = this;

      var funderFields = (0, _get3.default)(this.props.FunderStore, 'funder.custom_lien_fields', []),
          funderFieldTypes = (0, _get3.default)(this.props.FunderStore, 'funder.custom_lien_field_types'),
          dataFields = Object.keys((0, _get3.default)(this.lien, 'custom_field_data', [])),
          customFields = (0, _util.joinCustomFields)(funderFields, dataFields),
          fieldSets = (0, _chunk3.default)(customFields.map(function (field) {
        return (0, _util.getCustomFieldset)(funderFieldTypes, field);
      }), 50) // eslint-disable-line no-magic-numbers
      ;

      if (!customFields.length) {
        return null;
      }

      return fieldSets.map(function (fieldSet, idx) {
        return _react2.default.createElement(_mightyFields.EditableCard, {
          key: 'custom-field-sets-' + idx,
          fieldSets: [fieldSet],
          model: _this3.lien.custom_field_data,
          onSave: _this3.updateCustomFields,
          title: 'Additional Lien Information'
        });
      });
    }
  }, {
    key: 'handleDeleteLienClick',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _props5, ApplicationStore, LienStore, onClose, SessionStore, caseId, lienId, lien;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _props5 = this.props, ApplicationStore = _props5.ApplicationStore, LienStore = _props5.LienStore, onClose = _props5.onClose, SessionStore = _props5.SessionStore, caseId = this.lien.case, lienId = this.lien.id, lien = (0, _has3.default)(this.lien, 'serialize') ? this.lien.serialize() : this.lien;


                onClose();
                _context5.next = 4;
                return Promise.all([LienStore.delete({ caseId: caseId, lienId: lienId }), SessionStore.trackEvent('LIEN_DELETED_EVENT', { lien: lien })]);

              case 4:
                _context5.next = 6;
                return ApplicationStore.list({ caseId: caseId });

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleDeleteLienClick() {
        return _ref5.apply(this, arguments);
      }

      return handleDeleteLienClick;
    }()
  }, {
    key: 'toggleShowDeleteLienConfirmation',
    value: function toggleShowDeleteLienConfirmation() {
      this.showDeleteLienConfirmation = !this.showDeleteLienConfirmation;
    }
  }, {
    key: 'renderLienDeleteButton',
    value: function renderLienDeleteButton() {
      return _react2.default.createElement(
        _ButtonToolbar2.default,
        { className: 'lien-delete' },
        _react2.default.createElement(_DeleteLienButton2.default, { onClick: this.toggleShowDeleteLienConfirmation })
      );
    }
  }, {
    key: 'closeMedicalCodeForm',
    value: function closeMedicalCodeForm() {
      this.editMedicalCodes = false;
    }
  }, {
    key: 'openMedicalCodeForm',
    value: function openMedicalCodeForm() {
      this.editMedicalCodes = true;
    }
  }, {
    key: 'addMedicalCode',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(codes) {
        var LienStore;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                LienStore = this.props.LienStore;
                _context6.next = 3;
                return LienStore.update(this.lien, { codes: codes });

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function addMedicalCode(_x4) {
        return _ref6.apply(this, arguments);
      }

      return addMedicalCode;
    }()
  }, {
    key: 'renderCodes',
    value: function renderCodes() {
      return _react2.default.createElement(
        _Well2.default,
        { className: 'well-medical-codes well-table' },
        this.editMedicalCodes ? _react2.default.createElement(_MedicalCodesFormGroup2.default, {
          deleteMedicalCode: this.deleteMedicalCode,
          medicalCodes: this.lien.codes || [],
          onClose: this.closeMedicalCodeForm,
          onSubmit: this.addMedicalCode
        }) : _react2.default.createElement(_MedicalCodesTable2.default, {
          deleteMedicalCode: this.deleteMedicalCode,
          hasCoopInvestment: this.lien.hasCoopInvestment,
          medicalCodes: this.lien.codes || [],
          onOpen: this.openMedicalCodeForm
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var onClose = this.props.onClose,
          confirmDeleteMessage = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Are you sure you want to delete this lien and application?'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Warning: this cannot be undone.'
          )
        )
      );


      return _react2.default.createElement(
        _Modal2.default,
        {
          className: (0, _classnames2.default)('modal-medical-details', 'right side-modal', 'large', { 'two-col': !this.loading }),
          onHide: onClose,
          show: true
        },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            'Medical Lien Details'
          )
        ),
        this.loading ? _react2.default.createElement(
          _Modal2.default.Body,
          null,
          _react2.default.createElement(
            'div',
            { className: 'loading' },
            'Loading...'
          )
        ) : _react2.default.createElement(
          _Modal2.default.Body,
          null,
          _react2.default.createElement(
            _Grid2.default,
            { className: 'col-wrapper', fluid: true },
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(
                _Col2.default,
                { className: 'col-left', lg: 6, md: 7, sm: 12, xs: 12 },
                this.renderMedicalFundingInfo(),
                this.renderApplicationInformation(),
                this.renderReturnDetails(),
                this.renderCodes(),
                this.renderDocumentTemplates(),
                this.renderMedicalLienDocuments(),
                this.renderCustomLienFields(),
                this.renderLienDeleteButton()
              ),
              _react2.default.createElement(
                _Col2.default,
                { className: 'col-right', lg: 6, md: 5, sm: 12, xs: 12 },
                this.renderMedicalFacilityInfo(),
                this.renderMedicalProviderInfo(),
                this.renderMedicalFacilityContactInfo(),
                this.renderCapitalProviders()
              )
            )
          ),
          _react2.default.createElement(_common.ConfirmDelete, {
            fixed: true,
            message: confirmDeleteMessage,
            showConfirmDelete: this.showDeleteLienConfirmation,
            onClickDelete: this.handleDeleteLienClick,
            onClickCancel: this.toggleShowDeleteLienConfirmation
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return MedicalDetailsModal;
}(_react.Component), _class3.propTypes = {
  ApplicationStore: _propTypes2.default.object.isRequired,
  caseId: _propTypes2.default.string.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  lienId: _propTypes2.default.string.isRequired,
  LienStore: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  SessionStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'lien', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'application', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'medicalFacility', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'showDeleteLienConfirmation', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'editMedicalCodes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'loading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'fetchLien', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchLien'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'update', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'update'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteMedicalCode', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'deleteMedicalCode'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDeleteLienClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleDeleteLienClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = MedicalDetailsModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APPLICATION_MODELS, 'APPLICATION_MODELS', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(applicationConfig, 'applicationConfig', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(medicalFacilityConfig, 'medicalFacilityConfig', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(medicalFacilityContactConfig, 'medicalFacilityContactConfig', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(medicalProviderConfig, 'medicalProviderConfig', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(formatDate, 'formatDate', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(MedicalDetailsModal, 'MedicalDetailsModal', '/app/src/components/page-case/MedicalDetailsModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/MedicalDetailsModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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